import React, {useEffect} from "react";

import {DEFAULT_ERROR_MODAL_CONTENT} from "@globals/constants/error_modal";
import {ExtendedError} from "@globals/types/ExtendedError";

import useInfoModal, {
  InfoModalProps,
} from "@components/Extras/hooks/useInfoModal";
import SupportEmail from "@components/SupportEmail";
import {ConfirmationModal, Modal} from "@components/modals";

// ErrorModal component listens for the changes in error object passed
// and displays ConfirmationModal with the error info;
// In the error object we can pass a custom title and message to the modal;
// In the defaultContent we can pass generic error texts for the errors;
// If none of the above is passed the texts from DEFAULT_ERROR_MODAL_CONTENT will be used;

export type ErrorModalProps = {
  error?: ExtendedError | null;
  defaultContent?: Omit<InfoModalProps, "isOpen">;
  onClose?: () => void;
};

const SupportMessage = (): JSX.Element => (
  <p>
    If the problem persists contact support at <SupportEmail />
  </p>
);

export default function ErrorModal({
  error,
  defaultContent = DEFAULT_ERROR_MODAL_CONTENT,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onClose = () => {},
}: ErrorModalProps): JSX.Element {
  const {infoModalProps, openInfoModal, closeInfoModal} = useInfoModal();

  useEffect(() => {
    if (error) {
      const errorContent = error.message || defaultContent.confirmationContent;

      openInfoModal({
        ...defaultContent,
        title: error.title || defaultContent.title,
        confirmationContent: (
          <>
            <p>{errorContent}</p>
            {error.addSupportMessage && <SupportMessage />}
          </>
        ),
      });
    }
  }, [error]);

  return (
    <Modal
      {...infoModalProps}
      onClose={() => {
        onClose();
        closeInfoModal();
      }}
      modalComponent={ConfirmationModal}
    />
  );
}
